import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

import CLIENT from 'af-constants/routes/client';

import { Button } from '@acceligentllc/storybook';

const Error403: React.FC = () => {

	const location = useLocation();
	const navigate = useNavigate();
	const orgAlias = location.state.orgAlias;

	const goToLogin = React.useCallback(() => {
		navigate(CLIENT.HOME(orgAlias));
	}, [navigate, orgAlias]);

	return (
		<div className="form-segment form-segment--mini">
			<div className="form-box form-box--standalone form-box--padded">
				<div className="form-box__icon-container">
					<span className="form-box__icon icon-key" />
				</div>
				<h2>Unauthorized access.</h2>
				<h4>
					You do not have permission to perform this action. Please contact your administrator to adjust your account settings and permissions.
				</h4>
				<div className="form-box__footer">
					<Button
						label="Back to Home"
						onClick={goToLogin}
						style="primary"
						type="button"
					/>
				</div>
			</div>
		</div>
	);

};

export default Error403;
